const $ = require('jquery');
const $map = $('#property-map');
let map;

// attach function name to window object so it doesn't get minified and changed (google maps js uses it for a callback)
window.initMap = function() {
  if ($map.length <= 0) {
    return false;
  }

  const latlng = window.LAT_LNG;
  map = new google.maps.Map($map[0], {
    zoom: 15,
    center: latlng
  });
  const marker = new google.maps.Marker({
    position: latlng,
    map: map
  });

  google.maps.event.addDomListener(window, 'resize', function() {
    map.setCenter(latlng);
  });
};
